import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { Option, Select } from 'components/atoms/select';
import { ModalHelperText } from '../../common';
import { ChannelSelectionModalTypes } from './channel-selection-modal.types';

export const ChannelSelectionModal = ({
  value,
  onClose,
  onSelect,
  channelsList = [],
  loading,
}: ChannelSelectionModalTypes) => {
  const [selected, setSelected] = useState<Option | undefined>(value);

  const transformedOptions: Option[] = useMemo(
    () =>
      channelsList.map((channel) => ({
        value: channel.id,
        label: channel.name,
      })),
    [channelsList],
  );

  return (
    <Modal
      visible
      title={
        <FormattedMessage id="settings.integrations.slack.channel_settings.modal.title" />
      }
      confirmLoading={false}
      okText={<FormattedMessage id="save" />}
      onCancel={onClose}
      onOk={() => onSelect(selected)}
      okButtonProps={{ disabled: !selected }}
    >
      <Select
        isLoading={loading}
        options={transformedOptions}
        value={selected}
        onChange={(option?: Option) => setSelected(option)}
      />
      <ModalHelperText>
        <FormattedMessage id="settings.integrations.slack.channel_settings.modal.helper" />
      </ModalHelperText>
    </Modal>
  );
};
